import * as recompose from "recompose";
import * as queryString from "query-string";

export type withQueryStringProps = {
  qs: { [param: string]: any }
}
export const withQueryString = recompose.defaultProps({
  qs: queryString.parse(window.location.search)
});
